var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "icon-hamburger",
        "data-name": "icon-hamburger",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25"
      }
    },
    [
      _c("path", {
        staticStyle: { opacity: "0.5" },
        attrs: {
          d: "M22.15,21.06H2.79a.9.9,0,0,1,0-1.8H22.15a.9.9,0,0,1,0,1.8Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { opacity: "0.5" },
        attrs: {
          d: "M22.15,14.28H2.79a.91.91,0,0,1,0-1.81H22.15a.91.91,0,0,1,0,1.81Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { opacity: "0.5" },
        attrs: {
          d: "M22.15,7.49H2.79a.91.91,0,0,1,0-1.81H22.15a.91.91,0,0,1,0,1.81Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#fff" },
        attrs: {
          d: "M22.15,20.51H2.79a.91.91,0,0,1,0-1.81H22.15a.91.91,0,0,1,0,1.81Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#fff" },
        attrs: {
          d: "M22.15,13.72H2.79a.91.91,0,0,1,0-1.81H22.15a.91.91,0,0,1,0,1.81Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#fff" },
        attrs: {
          d: "M22.15,6.93H2.79a.91.91,0,0,1,0-1.81H22.15a.91.91,0,0,1,0,1.81Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }